module.exports = __webpack_public_path__ + "static/media/GV.e5bb1a68.png";